import React, { useState, createContext, useEffect } from 'react'
import { useSelector } from 'react-redux'

/**
 * I made this context so it's easier to share isLoading
 * and we do not need to do propsDrilling
 */
export const onboardingContext = createContext(null)

export const OnboardingProvider = ({ children }) => {
  const talent = useSelector((state) => state.talent)
  const [isLoading, setIsLoading] = useState(false)
  const [step, setStep] = useState(1)
  const [progress, setProgress] = useState(20)

  useEffect(() => {
    if (talent) {
      if (talent.id?.length && step === 1) {
        setStep(2)
      }
    }
  }, [talent, step])

  return (
    <onboardingContext.Provider
      value={{ progress, setProgress, step, setStep, isLoading, setIsLoading }}
    >
      {children}
    </onboardingContext.Provider>
  )
}
